// Minimal fetch() polyfill for legacy browsers (BB10 / old WebKit).
// react-app-polyfill covers ES features (Promise/Map/Set/etc) but not Fetch.

/* eslint-disable no-var */

(function(global) {
    if (!global || typeof global.fetch === 'function') return;
    if (typeof XMLHttpRequest === 'undefined') return;

    function normalizeHeaders(headers) {
        var out = {};
        if (!headers) return out;
        for (var k in headers) {
            if (Object.prototype.hasOwnProperty.call(headers, k)) {
                out[k] = headers[k];
            }
        }
        return out;
    }

    function fetchPolyfill(url, options) {
        var opts = options || {};
        var method = (opts.method || 'GET').toUpperCase();
        var headers = normalizeHeaders(opts.headers);
        var body = (typeof opts.body !== 'undefined') ? opts.body : null;

        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            try {
                xhr.open(method, url, true);
            } catch (e) {
                reject(e);
                return;
            }

            // Best-effort credentials support (needed for session cookies).
            try {
                if (opts.credentials === 'include') {
                    xhr.withCredentials = true;
                }
            } catch (e) {}

            try {
                for (var h in headers) {
                    if (Object.prototype.hasOwnProperty.call(headers, h)) {
                        xhr.setRequestHeader(h, headers[h]);
                    }
                }
            } catch (e) {}

            xhr.onreadystatechange = function() {
                if (xhr.readyState !== 4) return;
                var responseText = ('response' in xhr) ? xhr.response : xhr.responseText;
                var response = {
                    ok: (xhr.status >= 200 && xhr.status < 300),
                    status: xhr.status,
                    statusText: xhr.statusText,
                    url: (xhr.responseURL || url),
                    text: function() { return Promise.resolve(responseText); },
                    json: function() {
                        return Promise.resolve().then(function() {
                            return JSON.parse(responseText || '{}');
                        });
                    }
                };
                resolve(response);
            };

            xhr.onerror = function() { reject(new TypeError('Network request failed')); };
            xhr.ontimeout = function() { reject(new TypeError('Network request failed')); };

            try {
                xhr.send(body);
            } catch (e) {
                reject(e);
            }
        });
    }

    global.fetch = fetchPolyfill;
})((typeof window !== 'undefined') ? window : (typeof self !== 'undefined' ? self : this));

